<script lang="ts" setup>
	import { type ClassNameValue } from 'tailwind-merge'
	import type { RouteLocationAsRelativeGeneric } from 'vue-router'
	import type { RouteLocationAsPathGeneric } from 'vue-router'

	const { variant = 'one', action = 'button' } = defineProps<{
		type?: HTMLButtonElement['type']
		text?: string
		variant?: 'one' | 'default'
		loading?: boolean
		action?: 'button' | 'link'
		to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric | undefined
		/**
		 * @description This only works when the action attribute is set to 'link'
		 * */
		target?: '_blank' | '_self' | '_parent' | '_top' | undefined
		external?: boolean
	}>()
	const attr = useAttrs()
	const cls = computed(() => {
		const c = String(attr?.class as ClassNameValue)
		return cn(
			variant === 'one' ? 'bg-green-deep hover:bg-green-deep/90 text-white w-full h-[50px]' : '',
			'font-semibold flex justify-center items-center active:scale-95 custom-transition-2 disabled:opacity-50 disabled:cursor-not-allowed',
			c
		)
	})
</script>
<template>
	<button v-if="action === 'button'" :type :class="cls" :disabled="loading">
		<slot>
			{{ text }}
		</slot>
		<tools-icon v-if="loading" icon="loader" dir="loader" :height="30" :width="30" />
	</button>
	<nuxt-link v-else-if="action === 'link'" :to="to || '/'" :class="cls" :disabled="loading" :target :external>
		<slot>
			{{ text }}
		</slot>
		<tools-icon v-if="loading" icon="loader" dir="loader" :height="30" :width="30" />
	</nuxt-link>
</template>

<style></style>
